import { Component, Input, NgModule } from '@angular/core';
import { Cms } from '@impact/data';
import { NewCarsModule } from '../../new-cars/new-cars.module';

@Component({
    selector: 'app-new-cars-card-list-spot',
    template: `
        <app-new-cars-card-list
            [excludeModel]="data.excludeModel"
            [headerLink]="data.newCarsHeaderLink"
            [headerTextCustom]="data.newCarsHeaderText"
            [layoutMode]="data.layoutMode"
            [vehiclePageId]="data.makeFromNavigationNode?.id"
            [headerSize]="2"
        ></app-new-cars-card-list>
    `,
})
class NewCarsModelCardListSpotComponent {
    @Input() data: Cms.NewCarsModelCardListSpot;
}

@NgModule({
    declarations: [NewCarsModelCardListSpotComponent],
    imports: [NewCarsModule],
})
class NewCarsModelCardListSpotModule {}

export const LazySpotComponent = NewCarsModelCardListSpotComponent;
